import { render, staticRenderFns } from "./MastitisControlMeasures.vue?vue&type=template&id=e9bd0d2a&"
import script from "./MastitisControlMeasures.vue?vue&type=script&lang=js&"
export * from "./MastitisControlMeasures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports